import React from "react";
import { footerLinks } from "../constants/index";

const Footer = () => {
  return (
    <footer className="py-5 sm:px-10 px-5">
      <div className="screen-max-width">
        <div>
          <p className="font-semibold text-gray-600 text-xs ">
            More Ways To Shop:{" "}
            <span className="underline text-blue-500">
              Find an Apple Store{" "}
            </span>{" "}
            or <span className="underline text-blue-500">other retailer</span>{" "}
            near you.
          </p>
          <p className="font-semibold text-gray-600 text-xs ">
            Or call:0000-111-1946
          </p>
        </div>
        <div className="bg-neutral-700 my-5 h-[1px] w-full " />
        <div className="flex md:flex-row flex-col md:items-center justify-between">
          <p className="font-semibold text-gray-600 text-xs ">
            Copyright @ Apple Inc. All Rights Reserved.
          </p>
          <div className="flex">
            {footerLinks.map((link, i) => (
              <p className="font-semibold text-gray-600 text-xs">
                {link}{" "}
                {"i" !== footerLinks.length - 1 && (
                  <span className="sm:mx-2 mx-1">|</span>
                )}
              </p>
            ))}
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
